import React, { useState } from 'react';
import { 
    Paper, 
    Typography, 
    TextField, 
    Button, 
    Box,
    IconButton,
    Tooltip 
} from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

const ProblemStatementInput = ({ businessContext, onSubmit }) => {
    const [statement, setStatement] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Problem Statement submitted:', statement);

        onSubmit(statement);
    };

    const loadSampleData = () => {
        const sampleStatement = `Recording notes from whiteboards is tedious, error-prone, and  ineffective`;
        setStatement(sampleStatement);
    };

    return (
        <Paper sx={{ p: 4, mt: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">
                    Problem Statement
                </Typography>
                <Tooltip title="Load Sample Data">
                    <IconButton onClick={loadSampleData} color="primary">
                        <AutoFixHighIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            
            <Typography variant="body1" sx={{ mb: 3 }}>
                What problem does {businessContext.solution} solve for customers?
            </Typography>
            
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    value={statement}
                    onChange={(e) => setStatement(e.target.value)}
                    placeholder="Describe the core problem your solution addresses..."
                    sx={{ mb: 3 }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button 
                        variant="contained" 
                        type="submit"
                        disabled={!statement.trim()}
                    >
                        Continue
                    </Button>
                </Box>
            </form>
        </Paper>
    );
};

export default ProblemStatementInput;
